<form [formGroup]="formulario">
    <div class="container-fluid">
        <div class="row" *ngIf="administrador">
            <div class="col-6">
                <div class="form-group">
                    <label for="finalista">Es finalista: </label>
                    <c-form-check [switch]="true">
                        <input cFormCheckInput type="checkbox" formControlName="finalista" />
                        <label cFormCheckLabel>Finalista</label>
                    </c-form-check>
                </div>
            </div>
            <div class="col-6" *ngIf="formulario.value.finalista">
                <div class="form-group">
                    <label for="finalista">Es Ganador: </label>
                    <c-form-check [switch]="true">
                        <input cFormCheckInput type="checkbox" formControlName="ganador" />
                        <label cFormCheckLabel>Ganador</label>
                    </c-form-check>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="step === 1 || sinPaginacion">
            <div class="col-12">
                <div class="form-group" *ngIf="periodos.length > 0">
                    <label for="Periodos">Periodo del perfil</label>
                    <select name="periodo" id="periodo" formControlName="periodo_id" class="form-control">
                        <option *ngFor="let periodo of periodos" [value]="periodo.id">{{periodo.periodo}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="Nombre">Nombre del nominado</label>
                    <input type="text" name="Nombre" id="Nombre" class="form-control" placeholder="Nombre"
                        formControlName="nombre">
                </div>
                <div class="form-group">
                    <label for="Apellido">Apellido del nominado</label>
                    <input type="text" name="Apellido" id="Apellido" class="form-control" placeholder="Apellido"
                        formControlName="apellido">
                </div>
                <div class="form-group">
                    <label for="Departamento">¿En qué departamento nació?</label>
                    <select class="form-control" name="Departamento" id="Departamento" formControlName="departamento">
                        <option *ngFor="let dep of departamentos" [value]="dep">{{dep}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="Profesion">¿Cuál es su profesión?</label>
                    <input type="text" name="Profesion" id="Profesion" class="form-control" placeholder="Profesión"
                        formControlName="profesion">
                </div>
                <div class="form-group">
                    <p>
                        Sube una foto actual y en buena resolución de la persona que deseas nominar. Tamaño mínimo: 750
                        x
                        750 pixeles. Max: 1MB.
                    </p>
                    <div *ngIf="imagenPreview" (click)="file.click()"
                        class="row w-100 d-flex flex-column justify-content-center" id="container-upload"
                        style="background-image: url(assets/img/nominados/bordes.png); background-size: 100% 100%; background-position: center center; padding: 50px;width: 100%; min-height: 30vh; background-repeat: no-repeat; cursor: pointer;">
                        <img [src]="imagenPreview" class="m-auto" style="max-width: 250px; max-height: 250px;">
                    </div>
                    <img *ngIf="!imagenPreview" style="cursor: pointer;" src="assets/img/icon/subirImagen.svg"
                        width="100%" alt="Subir Imagen" (click)="file.click()">
                    <input style="display: none;" id="file-input" (change)="cambioImagen($event)"
                        accept="image/x-png,image/jpeg" type="file" #file />
                </div>
            </div>
        </div>
        <div class="row" *ngIf="step === 2 || sinPaginacion">
            <div class="col-12">
                <div class="form-group">
                    <label for="categoria">Selecciona la categoría a la que nominas a [{{formulario.value.nombre}}
                        {{formulario.value.apellido}}]
                    </label>
                    <div class="w-100 container-categorias row" [formGroup]="categorias">
                        <div class="item-categoria">
                            <img src="assets/img/icon/social.png" width="100%" alt="Social">
                            <span>Social</span>
                            <input type="checkbox" name="categoria" id="social" value="1"
                                (change)="actualizarCategorias($event)" formControlName="social">
                        </div>
                        <div class="item-categoria">
                            <img src="assets/img/icon/deporte.png" width="100%" alt="Deporte">
                            <span>Deporte</span>
                            <input type="checkbox" name="categoria" id="deporte" (change)="actualizarCategorias($event)"
                                formControlName="deporte">
                        </div>
                        <div class="item-categoria">
                            <img src="assets/img/icon/ciencia.png" width="100%" alt="Ciencia">
                            <span>Ciencia</span>
                            <input type="checkbox" name="categoria" id="ciencia" (change)="actualizarCategorias($event)"
                                formControlName="ciencia">
                        </div>
                        <div class="item-categoria">
                            <img src="assets/img/icon/empresarial.png" width="100%" alt="Empresarial">
                            <span>Empresarial</span>
                            <input type="checkbox" name="categoria" id="empresarial"
                                (change)="actualizarCategorias($event)" formControlName="empresarial">
                        </div>
                        <div class="item-categoria">
                            <img src="assets/img/icon/arte.png" width="100%" alt="Arte">
                            <span>Arte</span>
                            <input type="checkbox" name="categoria" id="arte" (change)="actualizarCategorias($event)"
                                formControlName="arte">
                        </div>
                        <div class="item-categoria" *ngIf="administrador">
                            <img src="assets/img/icon/elegido.png" width="100%" alt="Arte">
                            <span>Elegido Por El Público</span>
                            <input type="checkbox" name="categoria" id="elegidoPorElPublico" (change)="actualizarCategorias($event)"
                                formControlName="elegidoPorElPublico">
                        </div>
                        <div class="item-categoria" *ngIf="administrador">
                            <img src="assets/img/icon/orator.png" width="100%" alt="orator">
                            <span>Orator</span>
                            <input type="checkbox" name="categoria" id="orator" (change)="actualizarCategorias($event)"
                                formControlName="orator">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="descripcion_corta">Escribe descripción corta de la persona que deseas nominar.</label>
                    <textarea class="w-100" name="descripcion_corta" id="descripcion_corta" cols="30" rows="5"
                        placeholder="Escribe" formControlName="descripcion_corta">
                    </textarea>
                </div>
                <div class="form-group">
                    <label for="biografia">Escribe una detallada biografía de la persona que deseas nominar.</label>
                    <textarea name="biografia" id="biografica" cols="30" rows="10" placeholder="Escribe"
                        formControlName="descripcion_larga">
                    </textarea>
                </div>
                <div formArrayName="LogrosPerfil">
                    <div *ngFor="let logros of logrosFormulario.controls; let j = index">
                        <div class="form-group" [formGroupName]="j">
                            <label for="logro">Logro {{j + 1}}</label>
                            <input formControlName="logro" type="text" class="form-control"
                                [placeholder]="logros.value.holder" required>
                        </div>
                    </div>
                </div>
                <span class="actionLink agregarLogro" style="cursor: pointer;" (click)="agregarItems()">
                    Agregar otro logro
                </span>
                <div class="form-group">
                    <label for="desarrollandose">¿Cuántos años lleva desarrollándose en su carrera?</label>
                    <input type="number" name="desarrollandose" id="desarrollandose" class="form-control"
                        formControlName="desarrollo_carrera" placeholder="Ejemplo: 20" aria-describedby="helpId">
                </div>
                <div class="form-group">
                    <label for="personas">¿Cuántas personas se han visto beneficiadas o impactadas por su labor?</label>
                    <input type="number" name="personas" id="personas" class="form-control"
                        formControlName="personas_beneficiadas" placeholder="Ejemplo: 12,500" aria-describedby="helpId">
                </div>
                <div class="form-group">
                    <label for="politico">¿Forma parte de un grupo político o religioso?</label>
                    <select name="politico" id="politico" class="form-control"
                        formControlName="grupo_politico_religioso">
                        <option value="si">Si</option>
                        <option value="no">No</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="step === 3 || sinPaginacion">
            <div class="col-12">
                <p class="texto-form">Por favor, deja la información de contacto de [Nombre y Apellido Nominado]</p>
                <div class="form-group">
                    <label for="Correo">Correo</label>
                    <input type="email" name="Correo" id="Correo" class="form-control" formControlName="correo"
                        placeholder="" aria-describedby="helpId">
                </div>
                <div class="form-group">
                    <label for="telefono">Teléfono</label>
                    <input type="number" name="telefono" id="telefono" class="form-control" formControlName="telefono"
                        placeholder="" aria-describedby="helpId">
                </div>
                <div class="row text-center" style="text-align: center;">
                    <h3>Redes Sociales</h3>
                </div>
                <div formArrayName="RedSocialPerfil">
                    <div *ngFor="let redSocial of redesSocialFormulario.controls; let i = index">
                        <div class="form-group" [formGroupName]="i">
                            <label for="link">{{redSocial.value.redSocial}}</label>
                            <input formControlName="link" type="text" class="form-control"
                                [placeholder]="redSocial.value.redSocial" name="link" id="link">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="step === 4 || sinPaginacion">
            <div class="col-12">
                <p class="texto-form">
                    Por favor, deja tu información en caso de que se necesite corroborar algún dato de tu nominación.
                </p>
                <div class="form-group">
                    <label for="correoPersonal">Correo</label>
                    <input type="email" name="correoPersonal" id="correoPersonal" formControlName="correo_solicitante"
                        class="form-control">
                </div>
                <div class="form-group">
                    <label for="nombreApellido">Nombre y Apellido</label>
                    <input type="text" name="nombreApellido" id="nombreApellido" formControlName="nombre_solicitante"
                        class="form-control" placeholder="" aria-describedby="helpId">
                </div>
                <p class="texto-form">
                    Por favor, confirma tu nominación.
                </p>
                <div class="container-resumen row">
                    <div class="col-6 imagenPerfil">
                        <img [src]="imagenPreview" width="100%" alt="Perfil">
                    </div>
                    <div class="col-6">
                        <div class="row">
                            <div class="col-8">
                                <h6>
                                    <strong>{{formulario.value.nombre}} {{formulario.value.apellido}}</strong>
                                </h6>
                                <span>
                                    {{formulario.value.categoria.nombre}}
                                </span>
                            </div>
                            <div class="col-4">
                                <img [src]="formulario.value.categoria.imagen" width=" 100%" alt="Arte">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <p>
                                    {{formulario.value.descripcion_larga.length > 350 ?
                                    formulario.value.descripcion_larga.substr(0, 350) + '...' :
                                    formulario.value.descripcion_larga}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="d-flex flex-row justify-content-center vertical-align-midle text-center pt-5">
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input type="checkbox" formControlName="aceptar_terminos" class="form-check-input"
                                        name="terminos" id="terminos" required>
                                    Acepto los <a href="#/terminos" style="margin-left: 5px;" target="_blank"> términos
                                        y
                                        condiciones</a>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>